export default __webpack_public_path__ + "static/char-s-09-chs-36c169ab81b146069891c60bf759fa7e.png";